import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateFormatEnum, DynamicTemplateVariable, DynamicDocumentFieldsTypes, Signer, InlineFieldContext } from '@app/models';
import { PhonePipe } from '@app/shared/pipes';

@Component({
  selector: 'app-fill-dynamic-document-form',
  templateUrl: './fill-dynamic-document-form.component.html',
  styleUrl: './fill-dynamic-document-form.component.scss',
  standalone: false
})
export class FillDynamicDocumentFormComponent implements OnChanges {
  @Input() dateFormat: DateFormatEnum;
  @Input() currentSigner?: Signer;
  @Input() fieldsToFill: Array<DynamicTemplateVariable>;
  @Input() disabled = false;
  @Input() context: InlineFieldContext;

  @Output() submitFields = new EventEmitter<any>();

  fieldsForm?: FormGroup;
  isRendered: boolean = false;

  focusedField: string = null;

  readonly DynamicDocumentFieldsTypes = DynamicDocumentFieldsTypes;

  constructor(
    private formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    private phonePipe: PhonePipe
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fieldsToFill'] && changes['fieldsToFill'].currentValue) {
      this.generateFieldsForm(this.fieldsToFill);
    }
  }

  generateFieldsForm(fields: Array<DynamicTemplateVariable>) {
    let group: { [key: string]: string } = {};
    fields.map((field: DynamicTemplateVariable) => {
      group[field.name] = '';
    });

    this.fieldsForm = this.formBuilder.group({
      filledFields: this.formBuilder.group(group)
    });

    this.isRendered = true;
    this.changeDetectorRef.detectChanges();
  }

  presentResult() {
    let result!: Record<string, string>;
    const signerIdentifiers = Array.from(new Set(this.fieldsToFill.map(field => field.data_signer_id)));

    setTimeout(() => {
      result = this.fieldsForm.get('filledFields').value;

      Object.keys(result).forEach(field => {
        if (!result[field]) return;

        signerIdentifiers.forEach(signerIdentifier => {
          const query = `.field--${this.context === InlineFieldContext.FillSigner ? 'view' : 'inline'}[data-signer-id="${signerIdentifier}"][data-field-name="${field}"]`;
          document.querySelectorAll(query).forEach((inlineField: HTMLElement) => {
            const options = this.fieldsToFill.find(fieldToFill => fieldToFill.name === field);

            if (options.type !== 'checkboxField') {
              if (options.type === 'phoneField') {
                setTimeout(() => this.phonePipe.transform(result[field]).subscribe(value => (inlineField.innerText = value)));
              } else {
                inlineField.innerText = result[field];
              }

              inlineField.classList.add('field--filled');
            }
          });
        });
      });
    });
  }

  submitFilledFields() {
    if (this.fieldsForm.invalid) return;

    let result = this.fieldsForm.get('filledFields').value;
    this.submitFields.emit(result);
  }
}
